<!-- Toast container -->
<div class="fixed" role="status" aria-live="polite">
  <!-- Individual toasts -->
  @for (toast of toasts$ | async; track toast) {
    <div
      class="toast"
      [class.toast-enter]="true"
    [ngClass]="{
      'toast-success': toast.type === 'success',
      'toast-error': toast.type === 'error',
      'toast-warning': toast.type === 'warning',
      'toast-info': toast.type === 'info'
    }"
      role="alert"
      >
      <!-- Toast icons -->
      @switch (toast.type) {
        @case ('success') {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="stroke-current"
            fill="none"
            viewBox="0 0 24 24"
            aria-hidden="true"
            >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          }
          @case ('error') {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="stroke-current"
              fill="none"
              viewBox="0 0 24 24"
              aria-hidden="true"
              >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            }
            @case ('warning') {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="stroke-current"
                fill="none"
                viewBox="0 0 24 24"
                aria-hidden="true"
                >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              }
              @case ('info') {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="stroke-current"
                  fill="none"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                }
              }
              <!-- Toast message -->
              <span>{{ toast.message }}</span>
            </div>
          }
        </div>
